module.exports = __webpack_public_path__ + "static/media/event_slide_6.b7830b49.png";